module.exports = {
  __init__: [ 'modeling', 'bpmnUpdater' ],
  __depends__: [
    require(59),
    require(88),
    require(76),
    require(86),
    require(129),
    require(252),
    require(182),
    require(143),
    require(241),
    require(155),
    require(248)
  ],
  bpmnFactory: [ 'type', require(33) ],
  bpmnUpdater: [ 'type', require(35) ],
  elementFactory: [ 'type', require(36) ],
  modeling: [ 'type', require(37) ],
  layouter: [ 'type', require(34) ],
  connectionDocking: [ 'type', require(259) ]
};
